import axios from "axios";
import { setAlert } from "./alert";
import { setErrorsList } from "./errors";
import { logout } from "./auth";
import { removeErrors } from "reducers/errors";

import {
  loadingOnProviderDeaLicenseSubmit,
  providerDeaLicenseError,
  providerDeaLicenseUpdated,
  resetProviderDeaLicense,
} from "reducers/providerDeaLicenseReducer";

export const getProviderDeaLicenseById = (provider_id) => async (dispatch) => {
  dispatch(removeErrors());
  dispatch(loadingOnProviderDeaLicenseSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(
      `/api/admin/providers/${provider_id}/dea_license`,
      config
    );

    dispatch(providerDeaLicenseUpdated(res.data.response));
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    console.log(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          providerDeaLicenseError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const saveProviderDeaLicense =
  (formData, provider_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const res = await axios.post(
        `/api/admin/providers/${provider_id}/dea_license/save`,
        formData,
        config
      );

      if (res.data.status === true) {
        await dispatch(providerDeaLicenseUpdated(res.data.response));
        dispatch(setAlert(res.data.message, "success"));
        return res.data ? res.data : { status: false };
      } else {
        const errors = res.data.errors;
        dispatch(setAlert(res.data?.message, "danger"));

        if (errors.length) {
          dispatch(providerDeaLicenseError());
          dispatch(setErrors(errors));
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch(
            providerDeaLicenseError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

export const resetProviderDeaLicenseComponentStore = () => async (dispatch) => {
  await dispatch(resetProviderDeaLicense());
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch(providerDeaLicenseError());
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

export const removeProviderDeaLicenseErrors = () => async (dispatch) => {
  dispatch(removeErrors());
};
